module.exports = __webpack_public_path__ + "static/media/Expand.43f5fc09.svg";